import React, {useState, useRef, useEffect} from 'react';
import {Link} from 'react-router-dom'
import {motion, useInView} from 'framer-motion'
import { bar1, bar2, navBG } from '../Variants/navVariants';
import NavMobile from './NavMobile';
import '../CSS/nav.scss'
import NavDesktop from './NavDesktop';

const Nav = () =>{
    const [active, isActive] = useState(false);
    const [isMobile, setIsMobile] = useState(true);
    const ref = useRef();
    const inView = useInView(ref)

    useEffect(() => {
        inView ? setIsMobile(true) : setIsMobile(false)
    }, [inView])

    return(
        <nav>
            <h1>
                <Link to="/">{`JW`}</Link>
            </h1>
            <motion.div className='toggle-button'
            onClick={() => isActive(!active)}
            ref={ref}>
                <motion.span className='bar1'
                variants={bar1}
                animate={active ? 'animate' : 'initial'}></motion.span>
                <motion.span className='bar2'
                variants={bar2}
                animate={active ? 'animate' : 'initial'}></motion.span>
            </motion.div>
            <motion.div className={`toggle-background ${active ?  'active' : ''}`}
            variants={navBG}
            initial="initial"
            animate={active ? 'animate' : 'initial'}>
                {isMobile && (
                    <NavMobile active={active} isActive={isActive}/>
                )}
            </motion.div>
            {!isMobile && (
                <NavDesktop />
            )}
        </nav>
    )
}

export default Nav;